import libraries from './content/sagas'
import documents from './document/sagas'

export default [libraries, documents]
